import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-forest-green text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo and Brand */}
          <div className="flex flex-col items-center md:items-start">
            <img 
              src="/NorthPetLogo.png" 
              alt="NorthPet Inc. Logo" 
              className="h-16 w-16 object-contain mb-3"
            />
            <h3 className="text-xl font-bold">NorthPet Inc.</h3>
            <p className="text-moss-green italic mt-2">Adventure Awaits. Pets Included.</p>
          </div>

          {/* Website Info */}
          <div className="flex flex-col items-center">
            <h4 className="text-lg font-semibold mb-3">Visit Us Online</h4>
            <a 
              href="https://northpetinc.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-moss-green hover:text-white transition duration-300"
            >
              northpetinc.com
            </a>
            <Link
              to="/admin"
              className="mt-3 text-xs uppercase tracking-widest text-gray-300 hover:text-white transition duration-300"
            >
              Admin Access
            </Link>
          </div>

          {/* Paw Print Motif */}
          <div className="flex flex-col items-center md:items-end">
            <div className="text-moss-green text-6xl">
              🐾
            </div>
            <p className="text-sm mt-2 text-center md:text-right">
              Making every adventure better with your pet
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-moss-green mt-8 pt-6">
          <div className="text-center mb-4">
            <p className="text-sm mb-2">
              © {new Date().getFullYear()} NorthPet Inc. All rights reserved.
            </p>
            <p className="text-xs text-moss-green">
              A Canadian Corporation • Corporation Number: 1676559-9
            </p>
          </div>
          <div className="flex flex-col items-center gap-3">
            <div className="flex items-center gap-4">
              <span className="text-sm font-semibold">Follow Us:</span>
              <a
                href="https://www.facebook.com/northpetinc"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="NorthPet on Facebook"
                className="text-moss-green hover:text-white transition"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22 12.07C22 6.48 17.52 2 12 2S2 6.48 2 12.07c0 4.99 3.66 9.12 8.44 9.93v-7.03H7.9v-2.9h2.54V9.41c0-2.5 1.49-3.88 3.77-3.88 1.09 0 2.23.2 2.23.2v2.45h-1.25c-1.23 0-1.61.76-1.61 1.54v1.85h2.74l-.44 2.9h-2.3v7.03C18.34 21.19 22 17.06 22 12.07z"/>
                </svg>
              </a>
              <a
                href="https://www.instagram.com/northpetinc"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="NorthPet on Instagram"
                className="text-moss-green hover:text-white transition"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M7 2h10a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7a5 5 0 015-5zm5 6.3A4.7 4.7 0 1016.7 13 4.7 4.7 0 0012 8.3zm6.5-3.8a1.2 1.2 0 11-1.2 1.2 1.2 1.2 0 011.2-1.2z"/>
                </svg>
              </a>
              <a
                href="https://www.tiktok.com/@northpetinc"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="NorthPet on TikTok"
                className="text-moss-green hover:text-white transition"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16.5 7.5c-.4 0-.8-.1-1.1-.2v5.1c0 1.9-1.5 3.4-3.4 3.4-1.6 0-3-1.1-3.3-2.6-.3 0-.5 0-.8-.1 0 1.6.9 3 2.3 3.6.2.1.3.1.5.2 1.7.6 3.5.3 4.9-.7v2.2c-1.6 1.1-3.6 1.6-5.6 1.2-1.9-.4-3.5-1.8-4.1-3.6C6 15 7.2 13 9 12.3c.3-.1.6-.1.9-.1V6.6c.3.1.6.1.9.1 2.2 0 4-1.8 4-4V2h2.7c.1 2.9 1.8 5.6 4.5 7.1v.4c-1.4-.1-2.8-.7-3.6-1.6-.3.1-.6.1-1 .1z"/>
                </svg>
              </a>
              <a
                href="https://www.pinterest.com/northpetinc"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="NorthPet on Pinterest"
                className="text-moss-green hover:text-white transition"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12c0 4.05 2.54 7.51 6.12 9.02-.09-.77-.17-1.95.04-2.79.19-.81 1.23-5.15 1.23-5.15s-.31-.62-.31-1.53c0-1.43.83-2.5 1.87-2.5.88 0 1.3.66 1.3 1.45 0 .88-.56 2.19-.85 3.41-.24.99.51 1.8 1.51 1.8 1.81 0 3.21-1.91 3.21-4.66 0-2.43-1.75-4.13-4.25-4.13-2.9 0-4.61 2.18-4.61 4.43 0 .88.34 1.46.87 1.92.24.23.28.35.19.64-.06.21-.19.73-.24.94-.08.33-.32.44-.59.32-1.65-.7-2.66-2.52-2.66-4.06 0-3.3 2.4-6.33 6.93-6.33 3.64 0 6.48 2.6 6.48 6.07 0 3.62-2.28 6.53-5.45 6.53-1.07 0-2.07-.56-2.41-1.22 0 0-.57 2.18-.71 2.64-.25.92-.74 1.84-1.19 2.57C9.9 21.86 10.92 22 12 22c5.52 0 10-4.48 10-10S17.52 2 12 2z"/>
                </svg>
              </a>
              <a
                href="https://twitter.com/northpetinc"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="NorthPet on X (Twitter)"
                className="text-moss-green hover:text-white transition"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M22.46 6c-.77.35-1.6.58-2.46.69a4.15 4.15 0 001.82-2.28 8.27 8.27 0 01-2.63 1 4.13 4.13 0 00-7.05 3.76A11.72 11.72 0 013 4.79a4.13 4.13 0 001.28 5.51 4.07 4.07 0 01-1.87-.52v.05a4.13 4.13 0 003.31 4.04c-.5.14-1.02.18-1.56.07a4.13 4.13 0 003.85 2.86A8.29 8.29 0 012 19.54a11.72 11.72 0 006.29 1.84c7.55 0 11.68-6.26 11.68-11.68 0-.18 0-.35-.01-.53A8.36 8.36 0 0022.46 6z"/>
                </svg>
              </a>
            </div>

            <div className="text-center text-xs text-gray-300">
              <p>Contact Us: support@northpetinc.com</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
